import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    count: 1,
    baseURL:'https://h5.xianpipa.com',
    baseAPI:'https://h5.xianpipa.com/apis',
    LOCATION_INFO: {
      location: '',
      name: "",
      address: '',
    },
    formdata: {},
    scancarddata: {},
    kaopu:[],
    Focus:[],
    Guzhang:[],
    DtDzShu:[],//动态详情评论点赞数
    DtDzShu002:[],//同上的二级点赞数
    zan:[],//发现，圈子关注
    avatar:'',//头像或圈子头像
    qrcode:'',//二维码
    detailmsg:{},//缓存个人信息
    minesmsg:{},//缓存我的页面信息
  },
  getters: {
    getLocationinfo: function (state) {
      return state.LOCATION_INFO
    },
    getFormdata: function (state) {
      return state.formdata
    },
    getScancarddata: function (state) {
      return state.scancarddata
    },
    getKaopu:function(state){
      return state.kaopu
    },
    getFocus:function(state){
      return state.Focus
    },
    getGuzhang:function(state){
      return state.Guzhang
    },
    getDtDzShu:function(state){
      return state.DtDzShu
    },
    getDtDzShu002:function(state){
      return state.DtDzShu002
    },
    getZan:function(state){
      return state.zan
    },
    getAvatar:function(state){
      return state.avatar
    },
    getQrcode:function(state){
      return state.qrcode
    },
    getDetailmsg:function(state){
      return state.detailmsg
    },
    getMinesmsg:function(state){
      return state.minesmsg
    },
  },
  mutations: {
    changemap(state, LOCATION_INFO) {
      state.LOCATION_INFO = LOCATION_INFO
    },
    changeform(state, formTemp) {
      state.formdata = formTemp
    },
    changeScancard(state, scancarddata) {
      state.scancarddata = scancarddata
    },
    changekaopu(state,cookie_mid){
      state.kaopu = cookie_mid
    },
    changeFocus(state,cookie_mid){
      state.Focus = cookie_mid
    },
    changeGuzhang(state,cookie_mid){
      state.Guzhang = cookie_mid
    },
    changeDtDzShu(state,cookie_mid){
      state.DtDzShu = cookie_mid
    },
    changeDtDzShu002(state,cookie_mid){
      state.DtDzShu002 = cookie_mid
    },
    changeZan(state,cookie_mid){
      state.zan = cookie_mid
    },
    changeAvatar(state,url){
      state.avatar = url;    
    },
    changeQrcode(state,url){
      state.qrcode = url
    },
    changeDetail(state,detailmsg){
      state.detailmsg = detailmsg
    },
    changeMinesmsg(state,minesmsg){
      state.minesmsg = minesmsg
    },
  },
  actions: {
    changemapFun(context, LOCATION_INFO) {
      context.commit("changemap", LOCATION_INFO)
    },
    changeformFun(context, formTemp) {
      context.commit("changeform", formTemp)
    },
    changeScancardFun(context, formTemp) {
      context.commit("changeScancard", formTemp)
    },
    changeKaopuFun(context,cookie_mid){
      context.commit("changekaopu",cookie_mid)
    },
    changeFocusFun(context,cookie_mid){
      context.commit("changeFocus",cookie_mid)
    },
    changeGuzhangFun(context,cookie_mid){
      context.commit("changeGuzhang",cookie_mid)
    },
    changeDtDzShuFun(context,cookie_mid){
      context.commit("changeDtDzShu",cookie_mid)
    },
    changeDtDzShu002Fun(context,cookie_mid){
      context.commit("changeDtDzShu002",cookie_mid)
    },
    changeZanFun(context,cookie_mid){
      context.commit("changeZan",cookie_mid)
    },
    changeAvatarFun(context,url){
      context.commit("changeAvatar",url)
    },
    changeQrcodeFun(context,url){
      context.commit("changeQrcode",url)
    },
    changeDetailmsgFun(context,detailmsg){
      context.commit("changeDetail",detailmsg)
    },
    changeMinesmsgFun(context,minesmsg){
      context.commit("changeMinesmsg",minesmsg)
    },
  }

})
export default store



// WEBPACK FOOTER //
// ./src/store/index.js